import React, { FC, useContext, useEffect } from "react";
import { SessionContext } from "@app/pippa/session";
import {
  APIContext,
  DialogsContext,
  EventsContext,
  PippaContext,
} from "@app/pippa/provider";
import { buildHistoryMessages } from "@app/pippa/helpers/buildHistoryMessages";
import { buildActionMessages } from "@app/pippa/helpers/buildActionMessages";
import { introMessage } from "@app/pippa/models/constants";
import OverlayBackground from "@app/pippa/components/overlayBackground";
import Container from "@app/pippa/components/container";

const PippaBotWrapper: FC = () => {
  const { isWidgetOpen } = useContext(PippaContext);
  const { acknowledgementDialog, messageFeedbackDialog } =
    useContext(DialogsContext);
  const { close: closeMessageFeedbackDialog } = messageFeedbackDialog;
  const { getSession, isActiveSession, clearStorage } =
    useContext(SessionContext);
  const {
    restoreSession,
    getChatHistory,
    getWelcomeMessages,
    clearChatSession,
  } = useContext(APIContext);
  const { replaceMessages, setIsInputDisabled, setIsInputHidden } =
    useContext(EventsContext);

  useEffect(() => {
    if (!isWidgetOpen) {
      document.body.style.overflow = "";
      return;
    }

    document.body.style.overflow = "hidden";

    const session = getSession();
    if (session && isActiveSession(session)) {
      restoreSession(session.chatId);
      getChatHistory(session.chatId)
        .then(async ({ messages: history, isInputDisabled }) => {
          const messages = buildHistoryMessages(history, introMessage);
          const conversationStarted = messages.some((m) => m.isSendByUser);

          if (!conversationStarted) {
            try {
              const welcome = await getWelcomeMessages(session.chatId);
              replaceMessages([
                ...messages,
                ...buildActionMessages(welcome.messages),
              ]);
            } catch (error) {
              console.error("Error restoring welcome quick replies:", error);
              replaceMessages(messages);
            }
          } else {
            replaceMessages(messages);
          }

          setIsInputDisabled(isInputDisabled);
          setIsInputHidden(false);
        })
        .catch((error) => {
          console.error("Error restoring chat history:", error);
        });
    } else {
      clearStorage();
      clearChatSession();
      replaceMessages([introMessage]);
      setIsInputDisabled(false);
      setIsInputHidden(false);
      closeMessageFeedbackDialog();
      acknowledgementDialog.open({});
    }

    return () => {
      document.body.style.overflow = "";
      closeMessageFeedbackDialog();
    };
  }, [isWidgetOpen]);

  if (!isWidgetOpen) {
    return null;
  }

  return (
    <>
      <Container />
      <OverlayBackground />
    </>
  );
};

export default PippaBotWrapper;
